import videojs from 'video.js';
import { PresentationStatus } from '../../api/presentation';

export class LivePluginStub extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);

        player.loader().onLoadPlayCover(onLoadPlayCover.bind(player));
        player.loader().onLoadPresentation(onLoadPresentation.bind(player));
    }
}

function isLivePresentation(playStatus) {
    return playStatus === PresentationStatus.ScheduledForLive
        || playStatus === PresentationStatus.OpenForLive
        || playStatus === PresentationStatus.Live
        || playStatus === PresentationStatus.LivePaused
        || playStatus === PresentationStatus.LiveEnded;
}

function shouldLoad(presentationId, playCoverData, presentationData) {
    const { playStatus } = playCoverData;
    return playStatus === PresentationStatus.ScheduledForLive
        || playStatus === PresentationStatus.OpenForLive
        || playStatus === PresentationStatus.Live
        || playStatus === PresentationStatus.LivePaused
        || playStatus === PresentationStatus.LiveEnded;
}

function isLivePlayable(playStatus) {
    return playStatus === PresentationStatus.Live
        || playStatus === PresentationStatus.LivePaused;
}

async function onLoadPlayCover(presentationId, playCoverData, presentationData) {
    const player = this;
    if (shouldLoad(...arguments)) {
        if (!videojs.getPlugin('live')) {
            const { LivePlugin } = await import(/* webpackChunkName: 'live' */ './live.js');
            player.registerPlugin('live', LivePlugin);
        }
        
        player.live().init({
            presentationId,
            playStatus: playCoverData.playStatus,
            unixTime: playCoverData.unixTime,
            enableCountdown: playCoverData.enableLiveCountdown,
            delayLiveIndicationUntilPresentationDate: playCoverData.delayLiveIndicationUntilPresentationDate
        });

        return {
            playerOptions: {
                live: undefined,
                playcover: {
                    showPlayButton: isLivePlayable(playCoverData.playStatus)
                        && !(playCoverData.delayLiveIndicationUntilPresentationDate && Date.now() < playCoverData.unixTime)
                }
            }
        }
    }
}

function onLoadPresentation(presentationId, playCoverData, presentationData) {
    const player = this;
    const { metadata, streams, playerOptions } = presentationData;
    const slideStream = streams.find(stream => {
        return stream.streamType === 2;
    });
    if (isLivePresentation(metadata.playStatus)) {
        const enableDvr = playerOptions.live?.enableDvr ?? false;
        player.live().enableDvr = enableDvr;

        //On media load, if slidestream exists, start looking for new events from last loaded slide event as opposed to first event in presentation
        player.live().lastLiveEventTime = slideStream?.items[slideStream.items.length - 1]?.time ?? -1;
        return {
            metadata: {
                bookmark: Infinity
            },
            playerOptions: {
                live: undefined,
                settings: {
                    enableSeeking: enableDvr,
                    enableSpeedControl: false
                }
            }
        }
    }
    else {
        return Promise.resolve({
            playerOptions: { live: undefined }
        });
    }
}
